
const listeners = new Array<any>()
const key = "q"

export default class URLManager {
    
    static addOnChangeHandler = (h:Function):void => {
        listeners.push(h)

    }
    static putQueryString = (e:any, silent?:boolean):void => {
        const s =  b64EncodeUnicode(JSON.stringify(e))

        var loc = window.location.href
        var newLoc: string
        if(e===null) {
            // When a null is passed in, eliminate the query all together
            newLoc = loc.split("?", 1)[0]
        } else {
            newLoc = updateQueryStringParameter(loc, key, s)
        }


        if(loc != newLoc) {
            window.history.pushState({},"", newLoc);
            if(!silent){
                listeners.forEach((h:any)=>{
                    h(URLManager.getQueryString(newLoc))
                })
            }
        }
    }

    static getQueryStringValue = (e:any):string => {
        return b64EncodeUnicode(JSON.stringify(e))
    }

    static getQueryString = (url?:string, k?: string):any => {
        try {
            const q = getQueryString(k || key, url || "")
            if(q.length===0) {
                // If we do not have a q at all, return null
                return null
            } else {
                const qp = JSON.parse(b64DecodeUnicode(q))
                return qp
            }
        } catch (error) {
            console.error(error)
            // nothing to do and should not happen
            return null
        }
    }

    static getUri(uri:string, key:string, qs:any):string {
        const s = b64EncodeUnicode(JSON.stringify(qs))
        return  uri + "?" + key + "=" + s
    }

    static getQueryStringValueByKey = ( field:string, url:string ):string => {
        var href = decodeURI(url ? url : window.location.href);

        var reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
        var string = reg.exec(href);
        return string ? string[1] : "";
    }
}

// function encodeValues (vals: any): any {
//     if(typeof(vals)=="object"){
//         const keys = Object.keys(vals)
//         return keys.reduce((acc, k):any =>{
//             acc[k] = encodeURIComponent(vals[k])
//             return acc
//         }, {})
//     }
//     return vals


// }
// function decodeValues (vals: any): any {
//     if(vals && typeof(vals)=="object"){
//         const keys = Object.keys(vals)
//         return keys.reduce((acc, k):any =>{
//             try {
//                 acc[k] = decodeURIComponent(vals[k])
//             }
//             catch(err){
//                 console.log("falling")
//                 acc[k] = vals[k]

//             }
//             return acc
//         }, {})
//     }
//     return vals


// }

function b64EncodeUnicode(str) {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
            const cc:number = new Number('0x' + p1) as number
            return String.fromCharCode(cc);
    }));
}

function b64DecodeUnicode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

function getQueryString ( field:string, url:string ):string {
    var href = decodeURI(url ? url : window.location.href);

	var reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
    var string = reg.exec(href);
	return string ? string[1] : "";
};

function updateQueryStringParameter(uri:string, key:string, value:string):string {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  }
